// lib/Table/lib/consume.ts
var e = async ({ input: e }) => {
	if (Array.isArray(e)) throw Error("Table plugin expected string for consumption, not a list/array");
	if (typeof e != "string") throw Error("Table plugin expected string for consumption");
	return t(e);
}, t = (e) => {
	let { text: t } = JSON.parse(e.data);
	return {
		...e,
		data: {
			id: crypto.randomUUID(),
			class: "block",
			type: "core/table",
			properties: {
				type: "core/table",
				rel: "table",
				text: t
			},
			children: [{
				type: "core/table/row",
				class: "block",
				children: [{
					type: "core/table/row/cell",
					class: "text",
					children: [{ text: t }]
				}]
			}]
		}
	};
};
export { e as consume };
